import { FormEvent, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { novaOrganizacao } from '../../services/organizacao'
import { cpfCnpjMascara, validarCpfCnpj } from '../../helpers'
import { Button } from '../Styles'
import { toast } from 'react-toastify'
import logoImg from '../../assets/img/logo.png'
import whatsAppImg from '../../assets/img/whatsapp.png'
import './cadastroorganizacao.css'

function CadastroOrganizacao () {

    const navigate = useNavigate()

    const [tipo, setTipo] = useState ('')
    const [nome, setNome] = useState ('')
    const [email, setEmail] = useState('')
    const [organizacao, setOrganizacao] = useState ('')
    const [cnpjCpf, setCnpjCpf] = useState('')
    const [senha, setSenha] = useState ('')
    const [confirmarSenha, setConfirmarSenha] = useState ('')
    const [processando, setProcessando] = useState (false)

    function conferirSenha () {

        if (senha !== confirmarSenha) {

            setSenha ('')
            setConfirmarSenha('')
            return toast.warn('As senhas não conferem')
        }
    }

    const cnpjCpfChange = (e: any) => {
        
        const { value } = e.target

        setCnpjCpf (cpfCnpjMascara(value))
    }

    const validarcnpjCpf = (e: any) => {
        
        const { value } = e.target

        const resposta = validarCpfCnpj (value)

        if (resposta === false) {
            setCnpjCpf ('')
            return toast.warning('CPF/CNPJ Inválido.')
        }
    }

    const cadastrarOrganizacao = async (e: FormEvent) => {

        e.preventDefault()
        setProcessando (true)

        const payload = {
            tipo,
            cnpjCpf,
            nomeFantasia: organizacao,
            nomeUsuario: nome,
            emailUsuario: email,
            senhaUsuario: senha
        }

        try {
            
            const resposta = await novaOrganizacao (payload)

            if (resposta.status === 201) {

                setProcessando (false)
                toast.success('Dados Salvos com Sucesso')

                return navigate('/login')
            }

        } catch (error: any) {

            setProcessando (false)

            if (error.response.status === 405) {

                return toast.warn('Já existe um cadastro para o CPNJ/CPF informado, gentileza tentar outro diferente!')
            }

            if (error.response.status === 410) {
                
                return toast.warn('Já existe um usuário com este e-mail informado, gentileza tentar outro diferente!')
            }

            return toast.error('Falha ao Processar a sua Solicitação')
        }
    }

    useEffect (() => {

        const verificarTipo = () => {
            if (cnpjCpf.length === 20) {
                setTipo ('pessoa jurídica')
            } else {
                setTipo ('pessoa física')
            }
        }

        verificarTipo ()

    }, [cnpjCpf])
   
    return (
            <div id ="fundoCadastroOrganizacao">
                <section id = 'containerEsquerdoCadastro'>
                <div id='containerFormCadastrarOrganizacao'>
                    <span>
                        <img id="logoSistemaGesttor" src={logoImg} alt="logo do Sistema Gesttor"/>
                        <h1>Cadastre-se</h1>
                        <p>Tem uma conta? <strong id = 'cadastreSe' onClick={() => navigate ('/login')}>Login</strong> </p>
                    </span>
                    <form id = 'formLogin' onSubmit={cadastrarOrganizacao}>
                        <span className = 'formCampo'>
                            <label htmlFor="campoNome">Nome</label>
                            <input 
                                type = 'text' 
                                id = 'campoNome' 
                                className = 'campoOrganizacaoCadastro' 
                                placeholder="insira seu nome e sobrenome"
                                value={nome} 
                                required
                                onChange={(e) => setNome(e.target.value)}>
                            </input>
                        </span>
                        <span className = 'formCampo'>
                            <label htmlFor="campoNome">E-mail</label>
                            <input 
                                type = 'email' 
                                id = 'campoEmail' 
                                className = 'campoOrganizacaoCadastro' 
                                placeholder="insira seu e-mail" 
                                value={email}
                                required
                                onChange={(e) => setEmail(e.target.value)}>
                            </input>
                        </span>
                        <span className = 'formCampo'>
                            <label htmlFor="campoNome">Empresa</label>
                            <input 
                                type = 'text' 
                                id = 'campoNomeOrganizacao' 
                                className = 'campoOrganizacaoCadastro' 
                                placeholder="digite o nome fantasia do seu negócio"
                                value={organizacao} 
                                required
                                onChange={(e) => setOrganizacao(e.target.value)}>
                            </input>
                        </span>
                        <span className = 'formCampo'>
                            <label htmlFor="campoNome">CNPJ/CPF</label>
                            <input 
                                type = 'text' 
                                id = 'campoCnpjCpf' 
                                className = 'campoOrganizacaoCadastro' 
                                placeholder="digite o CNPJ ou CPF do seu negócio"
                                value={cnpjCpf}
                                minLength={14}
                                maxLength={20} 
                                required
                                onChange={cnpjCpfChange}
                                onFocus={() => toast.error('CPF/CNPJ Inválido')}
                                onBlur={validarcnpjCpf}>
                            </input>
                        </span>
                        <span className = 'formCampo'>
                            <label htmlFor="campoSenha">Senha</label>
                            <input 
                                type = 'password' 
                                id = 'campoSenha' 
                                className = 'senha' 
                                placeholder="insira sua senha com 8 dígitos"
                                value={senha} 
                                minLength= {8} 
                                maxLength= {8} 
                                required
                                onChange={(e) => setSenha(e.target.value)}>
                            </input>
                        </span>
                        <span className = 'formCampo'>
                            <label htmlFor="campoConfirmarSenha">Confirme a Senha</label>
                            <input 
                                type = 'password' 
                                id = 'campoConfirmarSenha' 
                                className = 'senha' 
                                placeholder="digite novamente a senha"
                                value={confirmarSenha} 
                                minLength= {8} 
                                maxLength= {8} 
                                required
                                onChange={(e) => setConfirmarSenha(e.target.value)}
                                onBlur={() => conferirSenha()}>
                            </input>
                        </span>
                        <span className='formCampo aceiteTermosContratacao'>
                            <input 
                                type="checkbox"
                                required/>
                            <label htmlFor="">Ao continuar você está de acordo com a nossa <a href="https://www.meuhg.com/politicaprivacidade" target='_blanck'>Política de Privacidade</a> e nossos <a href="https://www.meuhg.com/termosuso" target='_blanck'>Termos de Uso</a></label>
                        </span>    
                        <span id = 'formEntrar'>
                            <Button type='submit' isLoading={processando} cor='salvar'>Cadastrar</Button>
                        </span>
                    </form>
                </div>
            </section>
            <section id = 'containerDireitoCadastro'/>
            <a href="https://wa.me/message/YYTHX6J2OKZ3O1" target="_blanck">
                <span id="suporteSistemaGesttor">
                    <img src={whatsAppImg} alt="" title="Como podemos te ajudar?"/>
                    <p>Como podemos te ajudar?</p>
                </span>
            </a>
        </div>
    )
}

export default CadastroOrganizacao